import React from 'react'
import axios from 'axios'
import { useNavigate, Link } from 'react-router-dom'

const NextComparisonLink = ({listId, setError, optionIds}) => {
  const navigate = useNavigate()

  const createComparisonAndNavigate = () => {
    axios.put(`/api/lists/${listId}/pair_comparisons/${optionIds.join('/')}`)
    // axios.post(`/api/lists/${listId}/next_comparison`)
      .then(response => {
        const comparison = response.data
        const nextUrl = `/lists/${listId}/comparisons/${comparison.id}`
        navigate(nextUrl)
      })
      .catch(err => {
        setError(JSON.stringify(err))
      })
  }

  return (
    <Link onClick={() => createComparisonAndNavigate()}>
      Compare Selected Options
    </Link>
  )
}

export default NextComparisonLink
